import { SCRIPT_FIELDS_MODEL_PATH } from '../../../interfaces/imetadata';
import { FieldPathUtils } from '../../../utils/fieldpath-utils';
import { SerializedFieldContext } from '../../content-control-to-field-map.service';
import { PasteLocation } from '../paste-location';
import { IPasteRule } from './ipasterule';

export class PasteScriptFieldInDataFieldLocationRule implements IPasteRule {
  canPaste(pasteLocation: PasteLocation, pasteField: SerializedFieldContext): boolean {
    pasteLocation.location = pasteLocation.location as SerializedFieldContext;
    const taillessPasteFieldPath = FieldPathUtils.tailless(pasteField.path);
    const isTopLevelScriptField = taillessPasteFieldPath === SCRIPT_FIELDS_MODEL_PATH;
    const isPastedFieldChildOfThePasteLocation = taillessPasteFieldPath === pasteLocation.location.path;
    return isTopLevelScriptField || isPastedFieldChildOfThePasteLocation;
  }
}
